/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const policyLanguageBodySchema = z.object({
    "id": z.number().int().describe("Код языка"),
"name": z.string().describe("Название языка")
    })